'use client';
import { useEffect, useState } from 'react';
import Synopsis from '../synopsis';
import { db } from '@/lib/db';
import { useDispatch } from 'react-redux';
import { setSynopsisData } from '@/redux/slices/synopsis/synopsisSlice';
import { showSuccessToast, showErrorToast } from "@/components/toast/toast";

interface OfflineSynopsisProps {
  projectId: string;
  isOffline?: boolean;
}

export default function OfflineSynopsis({ projectId, isOffline }: OfflineSynopsisProps) {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const loadSynopsisData = async () => {
      if (projectId) {
        try {
          setIsLoading(true);
          const project = await db.getFullProject(projectId);

          if (project?.synopsisData) {
            dispatch(setSynopsisData(project.synopsisData));
          }
        } catch (error) {
          console.error('Error loading synopsis data:', error);
          showErrorToast('Failed to load synopsis configuration');
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    loadSynopsisData();
  }, [projectId, dispatch]);

  const handleOfflineSubmit = async (values: any) => {
    try {
      const project = await db.getFullProject(projectId);
      if (project) {
        await db.projects.update(projectId, {
          ...project,
          synopsisData: {
            ...values,
            updatedAt: new Date().toISOString()
          }
        });
        showSuccessToast("Synopsis data saved offline");
      }
    } catch (error) {
      console.error('Error saving synopsis data:', error);
      showErrorToast("Failed to save synopsis data");
    }
  };

  if (isLoading) {
    return <div>Loading synopsis configuration...</div>;
  }

  return (
    <Synopsis
      projectId={projectId}
      isOffline={isOffline}
      // onOfflineSubmit={handleOfflineSubmit}
    />
  );
}
